
import { defineComponent } from "vue";

export default defineComponent({
  name: "BreadCrumb",
  props: ["PageTitle"],
});
